<template>
  <div id="quem-somos" class="banner">
    <section>
      <h1>Informar para incluir</h1>
      <p>Acreditamos que a inclusão deve ser vista como um processo natural para a empresa e não como um ato filantrópico ou assistencialista. Nossa missão é auxiliar no acesso das pessoas com deficiência à diferentes esferas da sociedade que, até hoje, são excludentes e inacessíveis por esta parcela  da população.</p>
      <a href="#" class="btn-purple">Saiba mais sobre a Incluir Dá Certo</a>
    </section>
  </div>
</template>

<script>
export default {
  name: 'Banner',
  data () {
    return {
      msg: 'Incluir da Certo'
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "~styles/_bootstrap-variables";
  @import "~styles/_mixin-buttons";
  @import "~styles/_main";
  @import "~styles/_banner";
</style>



// WEBPACK FOOTER //
// src/components/Banner.vue